import {AfterViewInit, Directive, ElementRef, EventEmitter, Input, Output} from "@angular/core";

@Directive({
    selector: '[Infinite-Table]'
})
export class InfiniteTableDirective implements AfterViewInit {

    @Input() loadOffset: number = 0.90;
    @Output() onScroll = new EventEmitter<number>();
    @Output() onInfiniteLoad = new EventEmitter();

    constructor(
        private elRef: ElementRef
    ) {}

    ngAfterViewInit() {
        try {
            const scrollBody = this.elRef.nativeElement.getElementsByClassName('p-datatable-wrapper')[0];
            const origFunc = scrollBody.onscroll;

            scrollBody.onscroll = (...args: any) => {
                try {
                    if (typeof origFunc === 'function')
                        origFunc(...args);
                }
                finally {
                    this.onScroll.emit(scrollBody.scrollTop);

                    const scrollableHeight = scrollBody.scrollHeight - scrollBody.clientHeight;
                    if (scrollBody.scrollTop >= scrollableHeight * this.loadOffset)
                        this.onInfiniteLoad.emit();
                }
            };

        }
        catch (e) {
            console.error('Error during Infinite Table', e);
        }
    }
}